import styled, { css } from 'styled-components';

import {
  Block as BaseBlock,
  Footer as BaseFooter,
  ModalHead as BaseModalHead,
} from './details-modal.styled.default';

export * from './details-modal.styled.default';

const TH_FONT_COLOR = '#595050';

const paragraphColor = css`
  color: ${TH_FONT_COLOR};
`;

export const Block = styled(BaseBlock)`
  ${paragraphColor}
`;

export const Footer = styled(BaseFooter)`
  ${paragraphColor}
`;

export const ModalHead = styled(BaseModalHead)`
  border-bottom: none;

  h2 {
    font-size: 1.5rem;
  }
`;
